export const cleaningTeamKeys = {
  all: ['cleaning-teams'] as const,
  list: () => [...cleaningTeamKeys.all, 'list'] as const,
};
